/**
 * @file Lists a project's transactions, for use as transfer sources.
 */
import { indexTransactionsOperation } from "@api/services/transactions";

import type { Request, Transaction } from "../types";

type TransactionsOutput = {
  data: Transaction[];
};

/**
 * Fetches the project's transactions.
 */
const listProjectTransactions = async (request: Request, projectId: string): Promise<Transaction[]> => {
  const { data: projectTransactions } = await request<TransactionsOutput>(indexTransactionsOperation, { projectId });

  return projectTransactions;
};

export default listProjectTransactions;
